import {Component, OnInit} from '@angular/core';
import {PopulationRouteResolver} from "../../../population-taxpayers/population-route-resolver.service";
import {Subscription} from "rxjs";
import {IPopulation} from "../../../population-taxpayers/population-taxpayers.component";

@Component({
    selector: 'app-population-notes',
    templateUrl: './population-notes.component.html',
    styleUrls: ['./population-notes.component.scss'],
    standalone: false
})
export class PopulationNotesComponent implements OnInit {
  subscriptions: Subscription[] = [];
  population?: IPopulation;

  constructor(private populationRouteResolver: PopulationRouteResolver) {
  }

  ngOnInit() {
    this.subscriptions.push(this.populationRouteResolver.routePopulation().subscribe(routePopulation => 
      this.population = routePopulation.population));
  }

}
